

const FactoryApiCliente = (ApiReqJson) => {
  
  
  //const urlApi = 'http://localhost:8080/api-cliente'
  const urlApi = 'https://apiresec.researching.com.mx/api-cliente'
  
  const cuenta = async () => {
    const url = `${urlApi}/config-param?params=cuenta`;
    return await ApiReqJson.requestGET(url);
  }
  
  const allEse = async () => {
    const url = `${urlApi}/config-param?params=ese-all`;
    return await ApiReqJson.requestGET(url);
  }
  
  const home = async () => {
    const url = `${urlApi}/config-param?params=ese-last,usuarios,ese-tipo`;
    return await ApiReqJson.requestGET(url);
  }
  
  const solicitarConExcel = async () => {
    const url = `${urlApi}/config-param?params=ese-tipo`;
    return await ApiReqJson.requestGET(url);
  }
  
  const crearEse = async (att) => {
    //'id_tipo_ese', 'evaluado', 'puesto', 'email','tel', comCliente
    const url = `${urlApi}/ese`;
    return await ApiReqJson.requestPUT(url, att);
  }
  
  
  return {
    crearEse,
    cuenta,
    home,
    allEse,
    solicitarConExcel,
    s3:{
      get_read: async (uid) => {
        const url = urlApi + `/ese-url?uid=${uid}`;
        return await ApiReqJson.requestGET(url);
      }
    }
  }
  
}

export default FactoryApiCliente;
